var v1="<div class=\"form-group lbaSubHeading\"> <h4 class=\"lbaSubHeading_heading\" ng-class=\"vm.data[vm.settings.dataAt]\"><small>{{vm.settings.label}}</small>\n{{vm.data[vm.settings.dataAt]}} <div ng-if=\"vm.settings.html\" ng-bind-html=\"vm.settings.html\"></div> </h4> <label ng-if=\"vm.settings.titleHeader\" ng-bind-html=\"vm.settings.titleHeader\"></label> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaSubHeading.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaSubHeading/lbaSubHeading.html
// module id = 168
// module chunks = 0